export default function Pagination({ page, setPage, total, perPage = 10 }) {
  const pages = Math.max(1, Math.ceil(total / perPage));
  if (total <= perPage) return null;
  return (
    <div className="flex items-center justify-between gap-3 pt-1" data-testid="pagination">
      <span className="text-xs text-[#64748B]">Total : {total} · Page {page} sur {pages}</span>
      <div className="flex gap-2">
        <button className="btn-outline !py-1.5 !px-3" disabled={page <= 1} onClick={() => setPage(page - 1)} data-testid="page-prev">Précédent</button>
        <button className="btn-outline !py-1.5 !px-3" disabled={page >= pages} onClick={() => setPage(page + 1)} data-testid="page-next">Suivant</button>
      </div>
    </div>
  );
}
